import { useEffect } from "react";

import { useRouter } from "next/dist/client/router";
import { ActivitiesCard, type Activity } from "./ActivitiesCard";
import ExperiencesSlider from "@components/spotprofile/experiences-slider";
import { events, track } from "@shared/tracking";

interface FullScreenVideoProps {
  handleClose: () => void;
  exprience: {
    experienceId: number;
    title: string;
    posts: {
      postId: number;
      url: string;
      thumbnailUrl: string;
      userId: number;
      userThumbnail: string;
      username: string;
    }[];
    activities: Activity[];
    backgroundImage?: string;
  };
  section: string;
  expandActivities?: boolean;
}

export const FullScreenVideo = ({
  handleClose,
  exprience: { title, posts, activities, experienceId, backgroundImage },
  section,
}: FullScreenVideoProps) => {
  const router = useRouter();

  sessionStorage.setItem("title", title);

  useEffect(() => {
    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...router.query,

          experience_id: experienceId.toString(),
        },
      },
      undefined,
      { shallow: true }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [experienceId]);

  useEffect(
    () => {
      router.beforePopState(() => {
        handleClose();

        return false;
      });

      return () => {
        router.beforePopState(() => true);
      };
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );




  return (
    <ExperiencesSlider
      experienceId={experienceId}
      title={title}
      posts={posts}
      onClose={handleClose}
      section={section}
      backgroundImage={backgroundImage}
      isSingleActivity={activities.length === 1}
    >
      <ActivitiesCard
        activities={activities}
        eventsPayload={{
          city_id: router.query.id as string,
          ...(section === "experiences"
            ? { experience_id: experienceId.toString() }
            : { place_to_visit_id: experienceId.toString() }),
          section,
        }}
        onExpand={() => {
          router.replace(
            {
              query: {
                ...router.query,
                expand_activities: "true",
              },
            },
            undefined,
            { shallow: true }
          );
          track(events.EXPAND_ACTIVITIES, {
            city_id: router.query.id as string,
            [section === "experiences" ? "experience_id" : "place_to_visit_id"]:
              experienceId.toString(),
            section,

            ...(router.query.categories && {
              categories_ids: router.query.categories as string,
            }),
            ...(router.query.sortOption && {
              sort_by: router.query.sortOption as string,
            }),
          });
        }}
        onCollapse={() => {
          delete router.query.expand_activities;
          router.replace(
            {
              pathname: router.pathname,
              query: router.query,
            },
            undefined,
            { shallow: true }
          );

          track(events.SHRINK_ACTIVITIES, {
            city_id: router.query.id as string,
            [section === "experiences" ? "experience_id" : "place_to_visit_id"]:
              experienceId.toString(),
            section,
            ...(router.query.categories && {
              categories_ids: router.query.categories as string,
            }),
            ...(router.query.sortOption && {
              sort_by: router.query.sortOption as string,
            }),
          });
        }}
        spotTopExpId={experienceId}
      />
    </ExperiencesSlider>
  );
};
